<template>
  <VPage
    class="login-page-component"
    :show-user-menu="false"
  >
    <router-view/>

    <router-link
      class="link-back"
      to="/"
    >
      Вернуться на главную
    </router-link>
  </VPage>
</template>

<style lang="scss" src="./LoginPage.scss"/>

<script>
export default defineComponent({
  name: 'LoginPage',
});
</script>
